module.exports = __webpack_public_path__ + "img/rain-dark.e96d3536.png";